"use client";

import { useEffect, useState } from "react";

let sessionCache;
let sessionRequest = null;
const subscribers = new Set();

const notifySubscribers = (value) => {
  subscribers.forEach((setState) => setState(value));
};

const fetchSessionOnce = async () => {
  if (sessionRequest) {
    return sessionRequest;
  }

  sessionRequest = fetch("/api/session", {
    credentials: "include",
  })
    .then((response) => response.json())
    .then((result) => {
      sessionCache = result?.data?.access_token || null;
      notifySubscribers(sessionCache);
      return sessionCache;
    })
    .catch(() => {
      sessionCache = null;
      notifySubscribers(null);
      return null;
    })
    .finally(() => {
      sessionRequest = null;
    });

  return sessionRequest;
};

export const useSession = () => {
  const [session, setSession] = useState(
    sessionCache === undefined ? null : sessionCache
  );

  useEffect(() => {
    subscribers.add(setSession);
    if (sessionCache !== undefined) {
      setSession(sessionCache);
    } else {
      fetchSessionOnce();
    }

    return () => {
      subscribers.delete(setSession);
    };
  }, []);

  return { session, data: session };
};
